import { SET_TRIAL_BALANCE_FILTER, UNSET_TRIAL_BALANCE_FILTER } from './types';
import { CALCULATE_PROVISION_SUCCESS } from '../../store/types';
import { FETCH_PROVISION_DATA_SUCCESS } from '../../../shared/store/types';
import initialState from './initialState';

function trialBalanceReducer(state = initialState, action) {
  switch (action.type) {
    case SET_TRIAL_BALANCE_FILTER:
      return {
        ...state,
        trialBalanceFilter: action.filter,
      };
    case UNSET_TRIAL_BALANCE_FILTER:
      return {
        ...state,
        trialBalanceFilter: '',
      };
    case CALCULATE_PROVISION_SUCCESS:
    case FETCH_PROVISION_DATA_SUCCESS:
      return {
        ...state,
        trialBalanceCollection: action.provisionData.trialBalance,
        trialBalanceStatus: action.provisionData.trialBalanceStatus,
      };
    default:
      return state;
  }
}

export default trialBalanceReducer;
